var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.iconComponent,{tag:"component",class:_vm.classes,style:(_vm.innerStyle),attrs:{"alt":_vm.type,"role":"img"}})
}
var staticRenderFns = []

export { render, staticRenderFns }